// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/deals-list/deals-list.component.scss
// module id = 257
// module chunks = 0